import { openDB } from "idb";
import CryptoJS from "crypto-js";

const SECRET_KEY = "jW!03@2Hz";

const hashData = (data) => {
    return CryptoJS.MD5(JSON.stringify(data)).toString().substring(0, 16);
};

// 🔐 **Mã hóa dữ liệu trước khi lưu**
const encryptData = (data, useKey) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY + hashData(useKey)).toString();
};

// 🔍 **Giải mã dữ liệu khi lấy ra**
const decryptData = (cipherText, useKey) => {
    try {
        const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY + hashData(useKey));
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (error) {
        return null;
    }
};

/////ham sap xep cho sort cua organize
const compareSortMenu = (a, b) => {
    return a.position - b.position;
};
const compareSortOrganize = (a, b) => {
    const partsA = a.sort.split("_").filter(Boolean).map(Number);
    const partsB = b.sort.split("_").filter(Boolean).map(Number);

    const len = Math.max(partsA.length, partsB.length);

    for (let i = 0; i < len; i++) {
        const numA = partsA[i] ?? 0;
        const numB = partsB[i] ?? 0;

        if (numA !== numB) {
            return numA - numB;
        }
    }
    return 0; // bằng nhau
};
/////////////////////////////////////
////////////////////////////////////
const indexDB = {
    // 🔹 **Khởi tạo Database**
    async initDB(useKey) {
        if (typeof useKey !== "number" || useKey === 0 || isNaN(useKey)) {
            return;
        }
        const DB_NAME = window.DB_NAME + "_" + hashData(useKey);
        return openDB(DB_NAME, window.DB_VERSION, {
            upgrade(db) {
                Object.values(window.STORE_NAMES).forEach((storeName) => {
                    if (!db.objectStoreNames.contains(storeName)) {
                        const objectStore = db.createObjectStore(storeName, { keyPath: "id" });
                        objectStore.createIndex("server_id", "server_id", { unique: false });
                    }
                });
            },
        });
    },

    // 🔹 **Lưu nhiều dữ liệu vào Store**
    async saveAllStore(storeName, dataArray, useKey) {
        ////saveBulkData
        const db = await this.initDB(useKey);
        const tx = db.transaction(storeName, "readwrite");
        const store = tx.objectStore(storeName);

        for (const item of dataArray) {
            const existingData = await store.get(String(item.id));
            if (!existingData) {
                const defaultMeta = {
                    is_synced: 1,
                    sync_action: 0,
                };
                const newData = { ...item, ...defaultMeta };
                const encryptedData = await encryptData(newData, useKey);
                await store.put({ id: String(newData.id), server_id: Number(item.id), data: encryptedData });
            }
        }
        await tx.done;
    },
    // 🔹 **Lấy tất cả dữ liệu từ một Store**
    // async getAllStore(storeName, useKey) {
    //     ///getAllData
    //     const db = await this.initDB(useKey);
    //     const rawData = await db.getAll(storeName);
    //     if (!rawData || rawData.length === 0) return [];

    //     return rawData.map((item) => ({
    //         id: item.id,
    //         server_id: item.server_id,
    //         ...decryptData(item.data, useKey),
    //     }));
    // },
    async getAllStore(storeName, useKey, sortOrder = "ASC") {
        const db = await this.initDB(useKey);
        const rawData = await db.getAll(storeName);
        if (!rawData || rawData.length === 0) return [];

        const decryptedData = rawData.map((item) => ({
            id: item.id,
            server_id: item.server_id,
            ...decryptData(item.data, useKey),
        }));

        ///// Sắp xếp theo `id` (có thể thay bằng trường khác nếu bạn muốn)
        // decryptedData.sort((a, b) => {
        //     if (sortOrder === "DESC") return b.server_id - a.server_id;
        //     return a.server_id - b.server_id; // ASC mặc định
        // });
        if (storeName === "tbl_menu") {
            const sortedData = decryptedData.sort(compareSortMenu);
            return sortedData;
        }
        if (storeName === "tbl_organize") {
            const sortedData = decryptedData.sort(compareSortOrganize);
            return sortedData;
        } else {
            decryptedData.sort((a, b) => {
                const idA = Number(a.id); // ép kiểu từ string sang number
                const idB = Number(b.id);

                if (sortOrder === "DESC") return idB - idA;
                return idA - idB; // ASC mặc định
            });
            return decryptedData;
        }
    },
    // 🔹 **Lưu một dữ liệu vào Store**
    async saveStore(storeName, data, useKey) {
        const db = await this.initDB(useKey);
        const tx = db.transaction(storeName, "readwrite");
        const store = tx.objectStore(storeName);

        const defaultMeta = {
            is_synced: data.is_synced ?? 0,
            sync_action: data.sync_action ?? 2,
            is_deleted: data.is_deleted ?? 0,
        };

        const newData = {
            ...data,
            ...defaultMeta,
        };

        //const encryptedData = useKey ? encryptData(newData, useKey) : newData;
        const encryptedData = await encryptData(newData, useKey);

        // Nếu data.id chưa có thì id sẽ tự động được tạo
        const insertedId = await store.put({ id: String(data.id) ?? undefined, server_id: data.server_id ?? 0, data: encryptedData });

        await tx.done;

        return insertedId; // <- Trả về id mới
    },
    async getNextId(storeName, useKey) {
        const db = await this.initDB(useKey);
        const tx = db.transaction(storeName, "readonly");
        const store = tx.objectStore(storeName);

        const cursor = await store.openCursor(null, "prev"); // duyệt ngược → lấy dòng cuối
        const maxId = cursor?.key || 0;

        await tx.done;
        return Number(maxId) + 1;
    },

    // 🔹 **Lấy dữ liệu theo ID**
    async getStoreById(storeName, id, useKey) {
        const db = await this.initDB(useKey);
        const item = await db.get(storeName, String(id));

        if (!item) return null;
        return { id: item.id, server_id: item.server_id, ...decryptData(item.data, useKey) };
    },

    // 🔹 **Cập nhật dữ liệu**
    async updateStore(storeName, data, useKey) {
        const db = await this.initDB(useKey);
        const tx = db.transaction(storeName, "readwrite");
        const store = tx.objectStore(storeName);
        const defaultMeta = {
            is_synced: data.is_synced ?? 0,
            sync_action: data.sync_action ?? 2,
            is_deleted: data.is_deleted ?? 0,
        };

        const newData = {
            ...data,
            ...defaultMeta,
        };
        const encryptedData = await encryptData(newData, useKey);
        await store.put({ id: String(data.id), server_id: data.server_id ?? 0, data: encryptedData });
        await tx.done;
    },

    // 🔹 **Xóa dữ liệu theo ID**
    async deleteStore(storeName, id, useKey, isOnline) {
        const db = await this.initDB(useKey);
        const tx = db.transaction(storeName, "readwrite");
        const store = tx.objectStore(storeName);

        let existing = await store.get(String(id));
        if (!existing) return;

        const decryptedData = await decryptData(existing.data, useKey);

        // Nếu chưa từng đồng bộ lên server → xóa hẳn
        if (!existing.server_id || existing.server_id === "") {
            await store.delete(id);
        } else {
            // Nếu đã có server_id → chỉ đánh dấu xóa
            const updated = {
                ...decryptedData,
                sync_action: 3, // Đánh dấu là xóa
                is_synced: isOnline ? 1 : 0,
                is_deleted: 1,
            };
            console.log(updated);
            const encrypted = await encryptData(updated, useKey);
            await store.put({ id: String(id), server_id: existing.server_id, data: encrypted });
        }

        await tx.done;
    }, /////Hàm xử dụng Xóa hẳn id sau khi đồng bộ xóa xong
    async deleteStoreById(storeName, id, useKey) {
        const db = await this.initDB(useKey);
        const tx = db.transaction(storeName, "readwrite");
        await tx.objectStore(storeName).delete(String(id));
        await tx.done;
    },
    // 🔹 **Xóa toàn bộ dữ liệu trong Store**
    async clearStore(storeName, useKey) {
        const db = await this.initDB(useKey);
        const tx = db.transaction(storeName, "readwrite");
        await tx.objectStore(storeName).clear();
        await tx.done;
    },

    //////🔹 **Kiểm tra Store có dữ liệu không**
    async isStoreEmpty(storeName, useKey) {
        const db = await this.initDB(useKey);
        const tx = db.transaction(storeName, "readonly");
        const store = tx.objectStore(storeName);
        const cursor = await store.openCursor();
        return !cursor;
    },
    ///// Count row StoreName
    async countRows(storeName, useKey) {
        const db = await this.initDB(useKey);
        const tx = db.transaction(storeName, "readonly");
        const store = tx.objectStore(storeName);

        return store.count();
    },
    ////Check key of storeName exit
    async checkKeyExists(storeName, key, useKey) {
        const db = await this.initDB(useKey);
        const tx = db.transaction(storeName, "readonly");
        const store = tx.objectStore(storeName);

        const result = await store.getKey(key);
        return result !== undefined;
    },
    ////Lấy dữ liệu theo phân trang
    async getPagedData(storeName, useKey, page = 0, limit = 10, flag = 0, conditions = []) {
        const db = await this.initDB(useKey);
        const tx = db.transaction(storeName, "readonly");
        const store = tx.objectStore(storeName);
        const direction = flag === 1 ? "prev" : "next";

        // Helper: tạo IDBKeyRange cho điều kiện đơn nếu có index
        const makeKeyRange = (cond) => {
            const { operator, value } = cond;
            switch (operator) {
                case "===":
                case "==":
                    return IDBKeyRange.only(value);
                case ">":
                    return IDBKeyRange.lowerBound(value, true);
                case ">=":
                    return IDBKeyRange.lowerBound(value);
                case "<":
                    return IDBKeyRange.upperBound(value, true);
                case "<=":
                    return IDBKeyRange.upperBound(value);
                case "between":
                    return Array.isArray(value) && value.length === 2 ? IDBKeyRange.bound(value[0], value[1]) : null;
                case "startsWith":
                    return IDBKeyRange.bound(value, value + "\uffff");
                default:
                    return null;
            }
        };

        // Chọn cursor mở qua index nếu có 1 điều kiện duy nhất phù hợp
        let cursor = null;
        if (conditions.length === 1 && conditions[0].length === 1 && store.indexNames.contains(conditions[0][0].field)) {
            const idxCond = conditions[0][0];
            const kr = makeKeyRange(idxCond);
            const index = store.index(idxCond.field);
            cursor = await index.openCursor(kr, direction);
        } else {
            //cursor = await store.openCursor(null, direction);
            if (store.indexNames.contains("server_id")) {
                const index = store.index("server_id");
                cursor = await index.openCursor(null, direction);
            } else {
                cursor = await store.openCursor(null, direction);
            }
        }

        const results = [];
        const start = page * limit;
        let matchedCount = 0;

        // Các hàm lọc và so sánh
        const matchCondition = (item, { field, operator, value }) => {
            // bỏ qua nếu value rỗng
            if (value === undefined || value === null || value === "" || (Array.isArray(value) && value.length === 0)) {
                return true;
            }
            let fv = item[field];
            const strOps = ["contains", "startsWith", "endsWith", "regex"];
            if (strOps.includes(operator)) {
                fv = (fv || "").toString().toLowerCase();
                if (typeof value === "string") value = value.toLowerCase();
            }
            switch (operator) {
                case "===":
                    return fv === value;
                case "==":
                    return fv == value;
                case "!==":
                    return fv !== value;
                case "!=":
                    return fv != value;
                case "<":
                    return fv < value;
                case "<=":
                    return fv <= value;
                case ">":
                    return fv > value;
                case ">=":
                    return fv >= value;
                case "contains":
                    return fv.includes(value);
                case "startsWith":
                    return fv.startsWith(value);
                case "endsWith":
                    return fv.endsWith(value);
                case "between":
                    return Array.isArray(value) && value.length === 2 && fv >= value[0] && fv <= value[1];
                case "in":
                    return new Set(value.map(String)).has(String(fv));
                case "regex":
                    try {
                        return new RegExp(value, "i").test(fv);
                    } catch {
                        return false;
                    }
                default:
                    return false;
            }
        };
        // Hàm đánh giá điều kiện
        const evaluateConditions = (item, { andConditions = [], orConditions = [] }) => {
            // Kiểm tra điều kiện AND (tất cả phải đúng)
            const andSatisfied = andConditions.every((cond) => matchCondition(item, cond));
            if (!andSatisfied) return false;

            // Nếu không có điều kiện OR, chỉ cần AND là đủ
            if (orConditions.length === 0) return true;

            // Kiểm tra OR: ít nhất một nhóm trong orConditions phải đúng
            return orConditions.some((group) => {
                if (!Array.isArray(group) || group.length === 0) return false;
                return group.every((cond) => matchCondition(item, cond));
            });
        };

        // Bắt đầu duyệt
        while (cursor) {
            // nếu chưa đạt tới trang, chỉ đếm chứ chưa lưu
            let decrypted;
            try {
                decrypted = { id: cursor.value.id, ...decryptData(cursor.value.data, useKey) };
            } catch {
                // nếu lỗi giải mã, bỏ qua
                cursor = await cursor.continue();
                continue;
            }

            if (evaluateConditions(decrypted, conditions)) {
                if (matchedCount >= start) {
                    results.push(decrypted);
                    if (results.length >= limit) break;
                }
                matchedCount++;
            }

            // lấy cursor tiếp
            cursor = await cursor.continue();
        }

        // Kết quả đã đủ hoặc hết dữ liệu
        return results;
    },
    ///🔹 search trong storeName
    /**
     * Tìm kiếm các bản ghi trong IndexedDB theo nhiều trường
     * @param {string} storeName - Tên store trong IndexedDB
     * @param {object} conditions - Object điều kiện tìm kiếm (key: tên trường, value: giá trị cần tìm)
     * @param {string|null} useKey - Khóa dùng để giải mã dữ liệu nếu có
     * @returns {Promise<array>} - Mảng kết quả tìm được (đã giải mã nếu có useKey)
     */
    ////cách dùng
    // const results = await searchStoreAdvanced.call(this, "users", [
    //     { field: "age", operator: "between", value: [20, 30] },
    //     { field: "status", operator: "in", value: ["active", "pending"] },
    //     { field: "email", operator: "regex", value: "^user.*@example\\.com$" }
    // ], "yourSecretKey");

    async searchStore(storeName, conditions = [], useKey) {
        const db = await this.initDB(useKey);
        const tx = db.transaction(storeName, "readonly");
        const store = tx.objectStore(storeName);
        const results = [];

        // Helper: tạo KeyRange cho trường hợp điều kiện đơn với index
        const makeKeyRange = ({ operator, value }) => {
            // eslint-disable-next-line default-case
            switch (operator) {
                case "===":
                case "==":
                    return IDBKeyRange.only(value);
                case ">":
                    return IDBKeyRange.lowerBound(value, true);
                case ">=":
                    return IDBKeyRange.lowerBound(value);
                case "<":
                    return IDBKeyRange.upperBound(value, true);
                case "<=":
                    return IDBKeyRange.upperBound(value);
                case "between":
                    if (Array.isArray(value) && value.length === 2) {
                        return IDBKeyRange.bound(value[0], value[1]);
                    }
                    break;
                case "startsWith":
                    return IDBKeyRange.bound(value, value + "\uffff");
                default:
                    return false;
            }
        };

        // Lấy cursor: nếu chỉ có 1 điều kiện phù hợp với 1 index thì openCursor qua index
        let cursor;
        if (conditions.length === 1 && store.indexNames.contains(conditions[0].field)) {
            const kr = makeKeyRange(conditions[0]);
            const idx = store.index(conditions[0].field);
            cursor = await idx.openCursor(kr, "next");
        } else {
            cursor = await store.openCursor(null, "next");
        }

        // So sánh 1 điều kiện
        const matchSingle = (item, { field, operator, value }) => {
            let fv = item[field];
            // ép string với các operator chuỗi
            const strOps = ["contains", "startsWith", "endsWith", "regex"];
            if (strOps.includes(operator)) {
                fv = (fv || "").toString().toLowerCase();
                if (typeof value === "string") value = value.toLowerCase();
            }
            switch (operator) {
                case "===":
                    return fv === value;
                case "==":
                    return fv == value;
                case "!==":
                    return fv !== value;
                case "!=":
                    return fv != value;
                case "<":
                    return fv < value;
                case "<=":
                    return fv <= value;
                case ">":
                    return fv > value;
                case ">=":
                    return fv >= value;
                case "contains":
                    return fv.includes(value);
                case "startsWith":
                    return fv.startsWith(value);
                case "endsWith":
                    return fv.endsWith(value);
                case "between":
                    return Array.isArray(value) && value.length === 2 && fv >= value[0] && fv <= value[1];
                case "in":
                    return Array.isArray(value) && value.includes(fv);
                case "regex":
                    try {
                        return new RegExp(value, "i").test(fv);
                    } catch {
                        return false;
                    }
                default:
                    return false;
            }
        };

        // Kết hợp AND trên toàn mảng conditions
        const matchAll = (item, conds) => conds.every((cond) => matchSingle(item, cond));

        // Duyệt cursor
        while (cursor) {
            const item = cursor.value; // Lấy giá trị cursor

            if (item) {
                // Kiểm tra nếu item tồn tại
                let dataObj;
                try {
                    const raw = item.data;
                    dataObj = useKey ? decryptData(raw, useKey) : raw;
                } catch {
                    // lỗi giải mã → bỏ qua
                    cursor = await cursor.continue();
                    continue;
                }

                if (matchAll(dataObj, conditions)) {
                    // nếu match, thêm vào kết quả
                    results.push(dataObj);
                }
            }

            cursor = await cursor.continue();
        }

        return results;
    },
    async syncFromServerToStore(storeName, serverData, useKey, tableInstance) {
        const db = await this.initDB(useKey);
        const tx = db.transaction(storeName, "readwrite");
        const store = tx.objectStore(storeName);
        for (const item of serverData) {
            const id = item.id;

            if (item.is_deleted) {
                const record = {
                    id: String(item.id),
                    server_id: item.server_id,
                    data: encryptData(
                        {
                            ...item,
                            is_synced: 1,
                            is_deleted: 1,
                            sync_action: 0,
                        },
                        useKey,
                    ),
                };
                await store.put(record); // không xóa, chỉ cập nhật
                const rowIdx = tableInstance
                    .rows()
                    .indexes()
                    .filter((idx) => {
                        const rowData = tableInstance.row(idx).data();
                        return String(rowData.id) === String(id);
                    });
                if (rowIdx.length > 0) {
                    tableInstance.row(rowIdx[0]).remove();
                }
            } else {
                const encryptedData = encryptData(
                    {
                        ...item,
                        is_synced: 1,
                        sync_action: 0,
                        //server_id: item.id,
                    },
                    useKey,
                );
                const record = {
                    id: String(item.id),
                    server_id: Number(item.id),
                    data: encryptedData,
                };
                await store.put(record);
                const decryptedItem = { ...item };
                const rowIdx = tableInstance
                    .rows()
                    .indexes()
                    .filter((idx) => {
                        const rowData = tableInstance.row(idx).data();
                        return String(rowData.id) === String(id);
                    });
                if (rowIdx.length > 0) {
                    tableInstance.row(rowIdx[0]).data(decryptedItem);
                } else {
                    const currentData = tableInstance.rows().data().toArray();
                    const insertAt = currentData.findIndex((row) => String(row.id) < String(id));
                    if (insertAt === -1) {
                        currentData.push(decryptedItem);
                    } else {
                        currentData.splice(insertAt, 0, decryptedItem);
                    }
                    tableInstance.clear().rows.add(currentData);
                }
            }
        }
        await tx.done;
        tableInstance.draw(false);
    },
};

// Gán vào window để sử dụng toàn cục
window.indexDB = indexDB;
